import { allowedPrefillFields } from '@lower-financial/mortgage-utils';

export const isPrefillField = (field: string): field is typeof allowedPrefillFields[number] =>
  allowedPrefillFields.some((f) => f === field);
